import { FC } from 'react';

import { InvalidVerificationLinkGate } from '@components/pmi/src/common/InvalidVerificationLinkGate';

export const AccessBlockContainer: FC = () => {
  return <InvalidVerificationLinkGate />;
};
